import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useDataContext } from "../Context/dataContext";
import { toast, ToastContainer } from "react-toastify";
import { FaEnvelope } from "react-icons/fa";

function Recover() {
  const navigate = useNavigate();
  const { url } = useDataContext();
  const [email, setEmail] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Por favor, introduce un correo electrónico válido.");
      return;
    }
    try {
      await axios.post(`${url}/Mailer/emailRecovery/${email}`);
      toast.success("¡Correo de recuperación enviado! Revisa tu bandeja de entrada.");
      setTimeout(() => navigate("/Login"), 2000);
    } catch (error) {
      console.error("Error:", error);
      toast.error("Ocurrió un error. Por favor, intenta de nuevo.");
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-container">
        <h2>Recuperar Contraseña</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Correo Electrónico</label>
            <div className="input-container">
              <FaEnvelope className="input-icon" />
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="Ingresa tu correo electrónico"
              />
            </div>
          </div>
          <button type="submit">Enviar Enlace</button>
        </form>
      </div>
      <ToastContainer />
    </div>
  );
}

export { Recover };
